// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W69N","col":"styles_col__2W9a5"};